export default __webpack_public_path__ + "static/media/regulatory--end-of-one-way-straight--g1.2ed363d3.png";